import React from 'react';
import { Divider } from 'semantic-ui-react'

const VerCli1 = ({autorizacUA, styles, args, idLista, empresa, handleClickRegr, handleClickView,
                  handleClickHistFinanc, handleClickHistPago, handleClickHistFact,
                  handleClickHistNot, handleClickHistAj, handlePyS, handleImpContr, handleClickUpd,
                  handleClickUpdDir, handleClickDel, handleClickSel2, handleClickRecPago,
                  handleClickRecPagoOtr, handleClickRecPagoAdel, handleClickNCPF, handleClickProgNvoServ, handleClickNDF,
                  handleClickNCF, handleClickNCA, handleClickAjP, handleClickAjN, handleClickMNF}) => {

  //Traer autorizaciones
  const a010105 = autorizacUA.findIndex( autorizac => autorizac === "010105" );
  const a010107 = autorizacUA.findIndex( autorizac => autorizac === "010107" );
  const a010110 = autorizacUA.findIndex( autorizac => autorizac === "010110" );
  const a010115 = autorizacUA.findIndex( autorizac => autorizac === "010115" );
  const a010120 = autorizacUA.findIndex( autorizac => autorizac === "010120" );
  const a010125 = autorizacUA.findIndex( autorizac => autorizac === "010125" );
  const a010135 = autorizacUA.findIndex( autorizac => autorizac === "010135" );
  const a010140 = autorizacUA.findIndex( autorizac => autorizac === "010140" );
  const a010142 = autorizacUA.findIndex( autorizac => autorizac === "010142" );
  const a010143 = autorizacUA.findIndex( autorizac => autorizac === "010143" );
  const a010145 = autorizacUA.findIndex( autorizac => autorizac === "010145" );
  const a010150 = autorizacUA.findIndex( autorizac => autorizac === "010150" );
  const a010152 = autorizacUA.findIndex( autorizac => autorizac === "010152" );
  const a010155 = autorizacUA.findIndex( autorizac => autorizac === "010155" );
  const a010157 = autorizacUA.findIndex( autorizac => autorizac === "010157" );
  const a010159 = autorizacUA.findIndex( autorizac => autorizac === "010159" );
  const a010160 = autorizacUA.findIndex( autorizac => autorizac === "010160" );
  const a010165 = autorizacUA.findIndex( autorizac => autorizac === "010165" );
  const a010170 = autorizacUA.findIndex( autorizac => autorizac === "010170" );
  const a010175 = autorizacUA.findIndex( autorizac => autorizac === "010175" );
  const a010185 = autorizacUA.findIndex( autorizac => autorizac === "010185" );
// console.log(empresa)
  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Ver
      </button>

      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickView}>
        <i className="large address card outline violet icon"></i>
        Información principal
      </button>
      {a010115!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickHistFinanc(ev)}>
          <i className="large history violet icon"></i>
          Historia financiera
        </button>
      }
      {a010120!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickHistPago(ev, args)}>
          <i className="large money bill alternate outline violet icon"></i>
          Historial de pagos
        </button>
      }
      {a010125!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickHistFact(ev, args)}>
          <i className="large newspaper outline violet icon"></i>
          Historial de facturación
        </button>
      }
      {a010135!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickHistNot(ev, args)}>
          <i className="large newspaper outline violet icon"></i>
          Historial de ND / NC
        </button>
      }
      {a010140!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickHistAj(ev, args)}>
          <i className="large newspaper outline violet icon"></i>
          Historial de ajustes
        </button>
      }
      {(a010142!==-1 && idLista.saldoPendiente<=0) &&
        <div>
          <Divider inverted />

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handlePyS(ev, idLista, empresa)}>
            <i className="large newspaper outline violet icon"></i>
            Generar paz y salvo
          </button>
        </div>
      }
      {(a010143!==-1 && empresa.empresaArchFE==="supercablebq") &&
        <div>
          <Divider inverted />

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleImpContr(ev, idLista, empresa)}>
            <i className="large newspaper outline violet icon"></i>
            Imprimir contrato
          </button>
        </div>
      }

      {(a010145!==-1||a010150!==-1||a010155!==-1||a010160!==-1||a010165!==-1||a010170!==-1||a010175!==-1) &&
        <div>
          <Divider inverted />

          <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
            <i className="large sitemap yellow icon"></i>
            Opciones
          </button>
        </div>
      }

      {a010145!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickSel2(ev, args)}>
          <i className="large wrench violet icon"></i>
          Ordenes de Servicio
        </button>
      }
      {a010150!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickRecPago(ev)}>
          <i className="large money bill alternate outline violet icon"></i>
          Recibir pago
        </button>
      }
      {a010152!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickRecPagoOtr(ev)}>
          <i className="large money bill alternate outline violet icon"></i>
          Recibir otros pagos del cliente
        </button>
      }
      {a010157!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickNCPF(ev, args)}>
          <i className="large dollar sign violet icon"></i>
          Nuevos cargos próx fact
        </button>
      }
      {a010159!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickProgNvoServ(ev, args)}>
          <i className="large money bill alternate outline violet icon"></i>
          Programar nuevo servicio
        </button>
      }
      {a010155!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickRecPagoAdel(ev)}>
          <i className="large dollar sign violet icon"></i>
          Pago por adelantado
        </button>
      }
      {a010160!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickNDF(ev, args)}>
          <i className="large plus square outline violet icon"></i>
          ND a Factura
        </button>
      }
      {a010165!==-1 &&
        <div>
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickNCF(ev, args)}>
            <i className="large minus square outline violet icon"></i>
            NC a Factura
          </button>
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickNCA(ev, args)}>
            <i className="large minus square outline violet icon"></i>
            NC automática
          </button>
        </div>
      }
      {a010170!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickAjP(ev, args)}>
        <i className="large plus square outline violet icon"></i>
        Ajustes positivo
      </button>
      }
      {a010175!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickAjN(ev, args)}>
        <i className="large minus square outline violet icon"></i>
        Ajustes negativo
      </button>
      }

      {a010185!==-1 &&
        <Divider inverted />
      }
      {a010185!==-1 &&
        <div>
          <Divider inverted />
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickMNF(ev, args)}>
            <i className="large edit violet icon"></i>
            NO facturar Meses
          </button>
        </div>
      }

      {(a010105!==-1||a010107!==-1||a010110!==-1) &&
        <Divider inverted />
      }
      {a010105!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickUpd}>
          <i className="large edit violet icon"></i>
          Modificar
        </button>
      }
      {a010107!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickUpdDir}>
          <i className="large edit violet icon"></i>
          Cambiar dirección
        </button>
      }
      {a010110!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickDel}>
          <i className="large trash alternate violet icon"></i>
          Eliminar
        </button>
      }

      <Divider inverted />

      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>

    </div>
  )
};

export default VerCli1
